export default function isEmptyObject(value: object): boolean {
    return value && Object.keys(value).length === 0 && Object.getPrototypeOf(value) === Object.prototype;
}
